module.exports = __webpack_public_path__ + "static/usoutsideoxford2-33c56415a14d39b14480be8f23e3e887.jpg";